import type { IconSvgObject } from './types';

const ListChecksIcon: IconSvgObject = [
  ["path", { d: "M10.9961 6L20.9961 6", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.9961 12L20.9961 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10.9961 18L20.9961 18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2.99609 7.39286C2.99609 7.39286 3.99609 8.04466 4.49609 9C4.49609 9 5.99609 5.25 7.99609 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M2.99609 18.3929C2.99609 18.3929 3.99609 19.0447 4.49609 20C4.49609 20 5.99609 16.25 7.99609 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default ListChecksIcon;
